<template>
  <section>
    <overlay-alert
      :show-progress="showProgress"
      :process-alert="processAlert"
    />
    <div
      v-if="isWorkerDocVerifyFailed"
      class="fail-message-style mb-4"
    >
      <p
        v-for="(item, i) in workerDocVerificationStatus.expired_documents"
        :key="i"
        class="fail-style"
      >
        <v-icon
          color="#C62828"
          size="30"
        >
          mdi-alert
        </v-icon> <br>
        '{{ item.document_type.name }}' is expired, please upload the renewed file.
      </p>
    </div>
    <div
      v-if="verificationFailed"
      class="fail-message-style mb-4"
    >
      <p class="fail-style">
        <v-icon
          color="#C62828"
          size="30"
        >
          mdi-alert
        </v-icon> <br>
        {{ verificationFailedMessage }}
      </p>
    </div>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p
          v-if="locationEnableCheck"
          class="process-header"
        >
          Location Verification
        </p>
        <p
          v-else
          class="process-header"
        >
          User Details
        </p>
      </v-card-title>
      <v-card-text>
        <p class="title-text-style">
          Name : <font class="value-text-style">
            {{ selectedOrganization.first_name }} {{ selectedOrganization.last_name }}
          </font>
        </p>
        <p class="title-text-style">
          Mobile : <font class="value-text-style">
            {{ selectedOrganization.phone_number }}
          </font>
        </p>
        <p class="title-text-style">
          Company : <font class="value-text-style">
            {{ selectedOrganization.company? selectedOrganization.company.name : '' }}
          </font>
        </p>
        <p class="title-text-style">
          Category : <font
            v-if="selectedOrganization.worker_category !== null"
            class="value-text-style"
          >
            {{ selectedOrganization.worker_category.name }}
          </font>
          <font
            v-else
            class="value-text-style"
          >
            N/A
          </font>
        </p>
        <p class="title-text-style">
          High Risk Worker :<font
            :color="getHrwColor(selectedOrganization.high_risk_worker)"
          >
            {{ selectedOrganization.high_risk_worker | displayHighRisk }}
          </font>
        </p>
        <p class="title-text-style">
          Check-in Types :<font
            class="value-text-style"
          >
            {{ selectedOrganization.types | arrangePretty }}
          </font>
        </p>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      :disabled="locationFetchFailed"
      @click="doAllVerificationChecks()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>
  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import OverlayAlert from 'src/views/components/OverlayAlert';
  export default {
    name: 'WorkerLocationVerification',
    components: {
      'centre-spinner': spinner,
      'overlay-alert': OverlayAlert,
    },
    filters: {
      arrangePretty (val) {
  if (Array.isArray(val)) {
    return val.map(type => type === 'staff' ? 'Site Manager' : type).join(', ');
  }
  return val;
},
      displayHighRisk (status) {
        if (status === true) {
          return 'Yes*';
        } else {
          return 'No';
        }
      },
    },
    props: {
      orgSettings: {
        type: Object,
        default: null,
      },
    },
    data: () => ({
      loading: false,
      verificationFailed: false,
      verificationFailedMessage: '',
      showProgress: false,
      processAlert: '',
      latitudeValue: null,
      longitudeValue: null,
      showUploadForm: false,
      formSubTitle: '',
      locationFetchFailed: false,

    }),
    computed: {
      userDetails () {
        return this.$store.getters.getUser;
      },
      workerDocVerificationStatus () {
        return this.$store.getters['swiftuser/getWorkerDocVerifyStatus'];
      },
      isWorkerDocVerifyFailed () {
        if (Object.keys(this.workerDocVerificationStatus).length > 0 && this.workerDocVerificationStatus.verification_status === 'failed') {
          return true;
        }
        return false;
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      locationEnableCheck () {
        return this.orgSettings.location_verification;
      },
      documentVerificationCheck () {
        return this.orgSettings.document_verification;
      },
    },
    watch: {
      orgSettings (newval) {
        this.lv = newval;
      },
    },
    mounted () {
      this.fetchLocationDetails();
      this.$store.dispatch('swiftuser/clearWorkerDocVerifyStatus');
    },
    methods: {
      fetchLocationDetails () {
        if (navigator.geolocation) {
          this.showProgress = true;
          this.processAlert = 'Checking In...';
          navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
        } else {
          this.showProgress = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'Geolocation is not supported by this browser.';
        }
      },
      showPosition (position) {
        this.latitudeValue = position.coords.latitude;
        this.longitudeValue = position.coords.longitude;
        this.showProgress = false;
      },
      showError (error) {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'User denied the request for location access. Please close the tab and relaunch our app once access is enabled.';
          break;
          case error.POSITION_UNAVAILABLE:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'Location information is unavailable.';
          break;
          case error.TIMEOUT:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'The request to get user location timed out.';
          break;
          case error.UNKNOWN_ERROR:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'An unknown error occurred.';
          break;
        }
      },
      getHrwColor (value) {
        if (value === true) return '#C62828';
        else { return '#2E7D32'; }
      },
      async doAllVerificationChecks () {
        this.loading = true;
        this.$store.dispatch('swiftuser/clearScannedLocationName');
        this.$store.dispatch('swiftuser/clearWorkerDocVerifyStatus');
        const siteId = this.$route.params.siteId;
        await this.$store.dispatch('swiftuser/verifyLocation', {
          orgExtId: this.selectedOrganization.organization.external_id,
          details: {
          project_gate_id: siteId,
          checkin_latitude: this.latitudeValue.toString(),
          checkin_longitude: this.longitudeValue.toString(),
          checkin_type: 'check-in',
          },
        }).then(response => {
          if (this.documentVerificationCheck) {
            this.$store.dispatch('swiftuser/verifyDocuments', {
            organizationExtId: this.selectedOrganization.organization.external_id,
          }).then(response => {
            this.loading = false;
            if (this.isWorkerDocVerifyFailed === true) {
              return;
            }
            this.$emit('verification-completed');
          }).catch(error => {
            this.loading = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = error.response.data.message;
          });
          } else {
            this.$emit('verification-completed');
          }
        }).catch(error => {
          this.loading = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
      },
      openUploadForm () {
        this.formSubTitle = 'Please upload your expired documents here.';
        this.showUploadForm = true;
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckIn' });
        }, 1000);
      },
      onUploadSuccess () {
        this.showUploadForm = false;
        this.$store.dispatch('swiftuser/clearWorkerDocVerifyStatus');
        this.verificationFailed = false;
        this.verificationFailedMessage = '';
      },
    },
  };
</script>

<style scoped>
.v-btn.theme--dark.v-btn--disabled.v-btn--has-bg {
  background: rgb(202, 202, 202) !important;
}
</style>
